// extracted by mini-css-extract-plugin
export default {"bgWrapper":"AllItemsPage_bgWrapper__vekYh","empty-results":"AllItemsPage_empty-results__-xiwO"};